import { useEffect, useState } from "react";
import { toast } from "sonner";
import API from "../../lib/api";
import { Switch } from "../ui/switch";
import { BellRinging } from "@phosphor-icons/react";
import { err } from "./mpUtils";

export function NewContractorAlerts() {
  const [p, setP] = useState(null);
  useEffect(() => { API.get("/marketplace/prefs").then((r) => setP(r.data)).catch(() => setP({ new_contractor_alerts: true, searches: [] })); }, []);
  if (!p) return null;
  const toggle = async (v) => {
    try { const { data } = await API.put("/marketplace/prefs", { new_contractor_alerts: v }); setP((s) => ({ ...s, new_contractor_alerts: data.new_contractor_alerts })); toast.success(data.message); }
    catch (e) { err(e, "Couldn't update alerts"); }
  };
  const clear = async () => {
    try { const { data } = await API.delete("/marketplace/prefs/searches"); setP((s) => ({ ...s, searches: [] })); toast.success(data.message); }
    catch (e) { err(e, "Couldn't clear"); }
  };
  const recent = p.searches.slice(0, 5).map((s) => [s.trade, s.area || s.district || s.region].filter(Boolean).join(" · ")).filter(Boolean);
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground rounded-lg border border-dashed border-border px-3 py-2" data-testid="new-contractor-alerts">
      <BellRinging size={14} className={p.new_contractor_alerts ? "text-primary" : ""} />
      <label className="inline-flex items-center gap-2 cursor-pointer">
        <Switch checked={p.new_contractor_alerts} onCheckedChange={toggle} data-testid="alerts-toggle" />
        <span className="text-foreground font-medium">Tell me when a new contractor covers a trade or area I've searched</span>
      </label>
      {p.new_contractor_alerts && recent.length > 0 && <span data-testid="alerts-recent">Watching: {recent.join(", ")}{p.searches.length > 5 ? ` +${p.searches.length - 5} more` : ""}</span>}
      {p.new_contractor_alerts && recent.length === 0 && <span>Search by trade or postcode and we'll watch for new listings that match.</span>}
      {p.searches.length > 0 && <button onClick={clear} className="underline hover:text-foreground" data-testid="alerts-clear-btn">Clear history</button>}
    </div>
  );
}
